import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMap = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.5 15L1.66683 18.3334L1.66683 5.00008L7.5 1.66675M7.5 15L13.3335 18.3334M7.5 15L7.5 1.66675M13.3335 18.3334L18.3335 15L18.3335 1.66675L13.3335 5.00008M13.3335 18.3334L13.3335 5.00008M13.3335 5.00008L7.5 1.66675",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgMap;
